import React from 'react';
import { Button, Container, Image, Row } from 'react-bootstrap';
import './Banner.css';

const Banner = () => {
    return (
        <>
        <section className="banner">
            <Container className="">
                <Row>
                    <div className="col-md-6 banner-left-side mt-5">
                        <div className="left-side-info my-5">
                            <span className="text-light" style={{fontSize: '20px', textAlign: 'left'}}>Welcome To My World</span>
                            <h1 className="text-light mt-3" style={{fontSize: '45px', textAlign: 'left', fontWeight: '700'}}>Hi, I'm Md. Roman Sheikh</h1>
                            <p className="text-light mt-3 mb-5" style={{fontSize: '20px', textAlign: 'left'}}>I would like to introduce myself to you as I believe I am a passionate and dedicated person. I am always eager to learn different and new technologies related to web development and ICT. Expert to understand documentation and handle errors.</p>
                            <Button href="https://drive.google.com/file/d/1b3JFmK8733fafzVk-Uqmn_KAc7TzYLHv/view?usp=sharing" style={{backgroundImage: 'linear-gradient(90deg,#f61b10,#ef0963)', border: 'none', fontSize: '30px'}} className="text-btn fs-6 fw-bold py-3 px-5">See Resume</Button>
                        </div>
                    </div>
                    <div className="col-md-6">
                    <Image className="mt-3 banner-img" src="https://github.com/RomanSheikh99/Images/blob/main/myPic/myPic%20(2).png?raw=true" fluid />
                    </div>
                </Row>
            </Container>
        </section>
        </>
    );
};

export default Banner;